import { useLocation } from "react-router-dom";
import PositionsTable from "../components/positionsTable/positionsTable";

export default function PositionTablePage() {
  const { search } = useLocation();
  const params = new URLSearchParams(search);

  const type = params.get("type"); // LIGUE, TEAMS , SPORTS
  const sport = params.get("sport"); // TENIS, SOCCER, MOTORSPORT, FOOTBALL, BASKETBALL, BASEBALL
  const idEvent = params.get("idEvent"); // 7n3ltxz65zjcd8z9eyr5i2wb8
  const version= params.get("country");

  return (
    <PositionsTable sport={sport} idEvent={idEvent} type={type} version={version}/>
  )

}